import { Button, ButtonProps } from '@frontend/shadcn/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@frontend/shadcn/components/ui/tooltip';
import React, { MouseEventHandler } from 'react';

interface IButtonProps {
  onClick?: MouseEventHandler<HTMLElement>;
  icon?: React.ReactNode;
  disabled?: boolean;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  label?: string;
  iconPosition?: 'before' | 'after';
  loading?: boolean;
  tooltip?: string;
}

const HeaderButton: React.FC<IButtonProps> = ({
  onClick,
  icon,
  disabled,
  variant = 'outlineHeader',
  size = 'headerIcon',
  label,
  iconPosition = 'after',
  loading,
  tooltip
}) => (
  <TooltipProvider delayDuration={0}>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size={size}
          variant={variant}
          onClick={onClick}
          disabled={disabled}
          loading={loading}
          className="font-inter flex gap-1"
        >
          {iconPosition === 'before' && icon}
          {label}
          {iconPosition === 'after' && icon}
        </Button>
      </TooltipTrigger>
      {tooltip && (
        <TooltipContent
          className="z-[9999] bg-grey-0 text-grey-6 shadow-lg border border-gray-200 rounded-md px-3 py-2 font-medium max-w-[200px]"
          side="top"
          align="center"
          sideOffset={5}
        >
          {tooltip}
        </TooltipContent>
      )}
    </Tooltip>

  </TooltipProvider>
);

export default HeaderButton;
